import { Rule } from 'antd/lib/form';
import FormSelect from 'components/Select/FormSelect';
import { ISelectOption } from 'components/Select/types';
import React, { useMemo } from 'react';
import { clientTypes } from 'appConstants';
import breadcrumbs from 'assets/img/breadcrumbs.svg';
import { useTranslation } from 'react-i18next';
import { TCreateRestaurantSelectedClientType } from '../../../../../createRestaurantState/createRestaurantContext';
import style from './ClientTypeSelect.module.scss';

interface IClientTypeSelect {
	setClientType: (value: TCreateRestaurantSelectedClientType) => void;
}

const ClientTypeSelect: React.FC<IClientTypeSelect> = ({ setClientType }) => {
	const { t } = useTranslation('error');
	const { t: tForm } = useTranslation('form');
	const validationRules = useMemo<Rule[]>(() => [{ required: true, message: t('selectClientType') }], [t]);

	const mappedOptions = useMemo<ISelectOption[]>(() => {
		return clientTypes.map((el) => ({
			id: el.clientTypeID,
			name: tForm(el.clientTypeName),
			icon: (
				<svg className={style.icon}>
					<use xlinkHref={`${breadcrumbs}#${el.clientTypeName}`} />
				</svg>
			),
		}));
	}, [clientTypes, tForm]);

	return (
		<FormSelect
			containerClassName={style.select}
			testId="ClientTypeSelect"
			name="clientType"
			label="typeLabel"
			options={mappedOptions}
			onChange={setClientType}
			validationRules={validationRules}
		/>
	);
};

export default React.memo(ClientTypeSelect);
